import ky from 'ky'
import { env } from '@/env'
import { useAuthStore } from '@/store/auth.store'

export const api = ky.create({
  prefixUrl: env.VITE_API_URL,
  timeout: 15_000,
  hooks: {
    beforeRequest: [
      (request) => {
        const token = useAuthStore.getState().credentials?.deviceToken
        if (token) request.headers.set('Authorization', `Bearer ${token}`)
      }
    ]
  }
})
